'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const Table = styled__default.default.table `
  display: inline-table;
  min-width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
`;
const Tr = styled__default.default.tr `
  background: ${({ theme, variant }) => (variant === 'thead' ? theme.colors.border : theme.colors.body.background)};
`;
const Thead = styled__default.default.thead `
  text-align: left;
  padding: ${({ theme }) => theme.space.component.y.s} ${({ theme }) => theme.space.component.x.s}
    ${({ theme }) => theme.space.component.y.xs};
`;
const Td = styled__default.default.td `
  padding: ${({ theme }) => theme.space.component.y.s} ${({ theme }) => theme.space.component.x.l}
    ${({ theme }) => theme.space.component.y.s};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`;
const Th = styled__default.default.th `
  padding: ${({ theme }) => theme.space.component.y.s} ${({ theme }) => theme.space.component.x.l}
    ${({ theme }) => theme.space.component.y.s};
`;

exports.Table = Table;
exports.Td = Td;
exports.Th = Th;
exports.Thead = Thead;
exports.Tr = Tr;
//# sourceMappingURL=component.js.map
